import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.15 11.434h1.775a.566.566 0 1 1 0 1.132H3.15a8.831 8.831 0 0 0 2.192 5.292l1.255-1.256a.566.566 0 1 1 .8.801l-1.255 1.255a8.831 8.831 0 0 0 5.292 2.192v-1.774a.566.566 0 1 1 1.132 0v1.774a8.831 8.831 0 0 0 5.292-2.192l-1.254-1.253a.566.566 0 1 1 .8-.8l1.254 1.253a8.831 8.831 0 0 0 2.192-5.292h-1.774a.566.566 0 1 1 0-1.132h1.774a8.83 8.83 0 0 0-2.16-5.255l-4.6 4.536a2.453 2.453 0 1 1-.8-.801l4.604-4.54a8.832 8.832 0 0 0-5.328-2.224v1.775a.566.566 0 1 1-1.132 0V3.15a8.832 8.832 0 0 0-5.33 2.227L7.36 6.634a.566.566 0 0 1-.8.8L5.306 6.183a8.83 8.83 0 0 0-2.157 5.252Zm15.997 7.56A9.968 9.968 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.968 9.968 0 0 0 2.853 6.994.57.57 0 0 0 .153.153A9.967 9.967 0 0 0 12 22a9.968 9.968 0 0 0 6.994-2.853.56.56 0 0 0 .153-.153ZM12 10.679a1.32 1.32 0 1 0 0 2.642 1.32 1.32 0 0 0 0-2.642Z"
      clip-rule="evenodd"
    />
  </svg>
`;
